/** @format */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@tanstack/react-router";
import { formatDistanceToNow } from "date-fns";
import React from "react";
import type { Notification } from "@/api/notificationsApi";
import { getNotificationConfig } from "@/utils/notificationConfig";

interface NotificationItemProps {
  notification: Notification;
}

export const NotificationItem: React.FC<NotificationItemProps> = React.memo(
  ({ notification }) => {
    const config = getNotificationConfig(
      notification.category,
      notification.data?.incidentType as string | undefined
    );

    const timeAgo = formatDistanceToNow(new Date(notification.createdAt), {
      addSuffix: true,
    });

    // Determine link based on notification data
    const getLink = (): string | null => {
      if (notification.data?.runId ?? notification.data?.raceId) {
        return `/run/${(notification.data.runId ?? notification.data.raceId) as string}`;
      }
      return null;
    };

    const content = (
      <div className="px-4 py-3 hover:bg-slate-800 transition-colors cursor-pointer border-b border-slate-700 last:border-b-0">
        <div className="flex items-start gap-3">
          <FontAwesomeIcon icon={config.icon} className={`${config.color} mt-1`} />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-slate-200">{notification.title}</p>
            <p className="text-sm text-slate-400 mt-1">{notification.body}</p>
            <p className="text-xs text-slate-500 mt-1">{timeAgo}</p>
          </div>
        </div>
      </div>
    );

    const link = getLink();
    return link ? (
      <Link to={link} className="block">
        {content}
      </Link>
    ) : (
      <div>{content}</div>
    );
  }
);

NotificationItem.displayName = "NotificationItem";
